export { TemplateSettings } from "./TemplateSettings";



// WEBPACK FOOTER //
// ./src/features/admin/pages/template-editor/components/template-settings/index.ts